import CasesPage from './CasesPage';

export default CasesPage;
